import { Subscription } from 'rxjs';
import { FormArray, FormBuilder, FormGroup, Validators, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Component, Inject, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { PosCancelBillRemarkList } from '../../models/pos-cancel.model';

@Component({
  selector: 'app-cancel-product',
  templateUrl: './cancel-product.component.html',
  styleUrls: ['./cancel-product.component.scss'],
})
export class CancelProductComponent implements OnInit, OnDestroy {
  dialogTitle = '';
  dialogForm: FormGroup;
  subscriptions: Subscription[] = [];
  showErrorMessage = false;
  posCancelBillRemarkList: PosCancelBillRemarkList[] = [];
  constructor(
    public dialogRef: MatDialogRef<CancelProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.checkMode();
    this.initForm();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  checkMode(): void {
    if (this.data.mode === 1) {
      this.dialogTitle = 'รายการสินค้า';
    } else {
      this.dialogTitle = 'รายการบิล';
    }
  }

  getCancelList(): void {
    this.http.get<PosCancelBillRemarkList[]>(`pos_cancel_bill_remarks`).subscribe((result) => {
      this.posCancelBillRemarkList = result;

      this.posCancelBillRemarkList.forEach((x) => this.addCancelBillRemark(x));
    });
  }

  initForm(): void {
    this.dialogForm = this.fb.group(
      {
        // customer_cancel: [false],
        // staff_issue: [false],
        // customer_change: [false],
        // other: [false],
        // other_text: [{ value: '', disabled: true }, [Validators.required]],
        cancel_remark_list: this.fb.array([], hasCheckedItem()),
        is_return_stock: [false],
        is_not_return_stock: [false],
      },
      { validators: [StockhasChecked()] }
    );

    this.subscriptions.push(
      this.dialogForm.controls.is_return_stock.valueChanges.subscribe((change) => {
        if (change) {
          this.dialogForm.patchValue(
            {
              is_not_return_stock: false,
            },
            { emitEvent: false }
          );
        } else {
          this.dialogForm.patchValue(
            {
              is_return_stock: true,
              is_not_return_stock: false,
            },
            { emitEvent: false }
          );
        }
      })
    );
    this.subscriptions.push(
      this.dialogForm.controls.is_not_return_stock.valueChanges.subscribe((change) => {
        if (change) {
          this.dialogForm.patchValue(
            {
              is_return_stock: false,
            },
            { emitEvent: false }
          );
        } else {
          this.dialogForm.patchValue(
            {
              is_return_stock: false,
              is_not_return_stock: true,
            },
            { emitEvent: false }
          );
        }
      })
    );

    this.getCancelList();
  }

  get getFormControl() {
    return this.dialogForm.controls;
  }

  // control check cancel remark
  get getCancelBillRemarkControl(): FormArray {
    return this.dialogForm.get('cancel_remark_list') as FormArray;
  }

  addCancelBillRemark(data: PosCancelBillRemarkList): void {
    const cancelBillRemarkList = this.dialogForm.get('cancel_remark_list') as FormArray;
    cancelBillRemarkList.push(
      this.fb.group({
        ...data,
        is_checked: false,
      })
    );
  }

  onCancelBillRemarkChange(event): void {
    const cancelBillReMarkList = this.dialogForm.get('cancel_remark_list') as FormArray;
    cancelBillReMarkList.controls.filter((x) => x.patchValue({ is_checked: false }, { emitEvent: false }));
    cancelBillReMarkList.at(event).patchValue({ is_checked: true }, { emitEvent: false });
  }

  close(): void {
    this.dialogRef.close(false);
  }

  onSubmit(): void {
    this.showErrorMessage = false;
    if (this.dialogForm.invalid) {
      this.showErrorMessage = true;
      return;
    }

    const rawData = this.dialogForm.getRawValue();
    const remark = rawData.cancel_remark_list.filter((x) => x.is_checked === true)[0];
    const responseData = {
      skipStock: rawData.is_return_stock === true ? false : true,
      remark,
    };
    this.dialogRef.close(responseData);
  }
}

export function hasCheckedItem(): ValidatorFn {
  return (formArray: FormArray): { [key: string]: any } | null => {
    const checkeds = formArray.controls.map((x) => x.get('is_checked').value);
    const check_hasChecked = checkeds.some((checked) => checked === true);

    return check_hasChecked ? null : { onOneChecked: true };
  };
}

export function StockhasChecked(): ValidatorFn {
  return (form: FormGroup): ValidationErrors | null => {
    const isReturn: Date = form.get('is_return_stock').value;
    const isNotReturn: Date = form.get('is_not_return_stock').value;
    if (!isReturn && !isNotReturn) {
      return { returnStock: true };
    }
    return null;
  };
}
